(() => {
  'use strict';
  const form = document.getElementById('quote-form-page');
  if (!form) return;
  const storageKey = 'grs-quote-attempt';
  const read = () => { try { return sessionStorage.getItem(storageKey); } catch { return null; } };
  const write = value => { try { sessionStorage.setItem(storageKey, value); } catch {} };
  // A pending attempt is not a conversion. Shopify must confirm receipt first.
  form.addEventListener('submit', () => {
    if (form.checkValidity()) write('pending');
  });
  if (!form.querySelector('[data-quote-received]') || read() !== 'pending') return;
  let attempts = 0;
  const publish = () => {
    if (typeof window.Shopify?.analytics?.publish !== 'function') {
      if (++attempts < 20) window.setTimeout(publish, 500);
      return;
    }
    // No contact details, URL parameters, or project text enter analytics.
    Promise.resolve(window.Shopify.analytics.publish('grs:quote_submitted', {
      form: 'project_quote'
    })).then(published => {
      if (published !== false) write('reported');
    }).catch(() => {});
  };
  publish();
})();
